<!--
  File name: Bar.vue
  Program Description:
    - This component displays the bar graph from vue-chart-js reusable components.
    - It renders the bar graph according to the passed chart data.
-->
<script>
import { Bar, mixins } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    canvasHeight: {
      type: String,
      default: ''
    }
  },
  mounted () {
    if (this.canvasHeight) this.$refs.canvas.setAttribute('height', this.canvasHeight)
    this.addPlugin(ChartDataLabels)
    this.renderChart(this.chartData, this.options)
  }
}
</script>
